
import { useState } from 'react';
import { ClientIntakeData } from '@/components/meal-planning/ClientIntakeForm';

export const useClientPreferences = () => {
  const [clientPreferences, setClientPreferences] = useState<Partial<ClientIntakeData>>({});

  const updateClientPreferences = (preferences: Partial<ClientIntakeData>) => {
    setClientPreferences(preferences);
  };

  return {
    clientPreferences,
    updateClientPreferences
  };
};
